// @flow
import { combineReducers } from 'redux';
// eslint-disable-next-line no-duplicates, no-duplicate-imports
import type { Reducer } from 'redux';

import appReducer from './app';
import versionReducer from './version';
import type { Action, State } from './interfaces';

const rootReducer: Reducer<State, Action<*>> = combineReducers({
  app: appReducer,
  version: versionReducer
});

export type { State, Action } from './interfaces';
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js